import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import sha1 from "js-sha1";
import { getInitial, getPackages } from "./../api";
import { dispatch } from "./../store";

class Callback extends Component {
  componentDidMount = async () => {
    getPackages().then(packageResponse => {
      dispatch({
        type: "",
        isPackageLoading: false,
        packages: packageResponse
      });
    });
    const location = _.get(window, "location", {});
    const search = _.get(location, "search", "");
    if (search.length === 0) return true;
    const splittedData = search.slice(1, search.length).split("&");
    const params = {};
    let version = "v1";
    splittedData.forEach(data => {
      const splitMore = data.split("=");
      const key = _.get(splitMore, 0, "");
      const value = _.get(splitMore, 1, "");
      params[key] = value;
    });
    const token = _.get(params, "token", "");
    if (token) {
      getInitial(token)
        .then(response => {
          const userData = _.get(response, "current_user.data", {});
          const currentUser = _.get(response, "current_user", {});
          const email = _.get(userData, "email", "");
          const mobile = _.get(userData, "mobile", "");
          const prefill = _.get(currentUser, "prefill", false);
          version = _.get(currentUser, "version", "v1");
          let buyFor = "self";
          if (version !== "v1" && prefill === false) {
            buyFor = "other";
          }
          const splittedEmail = email.split("@");
          const nameEmail = _.get(splittedEmail, 0, "");
          const hash = sha1.hex(mobile + "+" + nameEmail);
          userData.distinct_id = hash;
          const mixpanel = _.get(window, "mixpanel", undefined);
          if (!!mixpanel) {
            mixpanel.identify(hash);
          }
          dispatch({
            type: "",
            buyFor,
            version,
            user: {
              ...userData
            },
            token: _.get(response, "tokenJWT", ""),
            system: {
              ..._.get(response, "systems", {})
            }
          });
        })
        .catch(error => {
          if (error.message === "Network Error") {
            const mixpanel = _.get(window, "mixpanel", undefined);
            if (!!mixpanel) {
              mixpanel.track("Insurance Corona Error", {
                "Insurance type": "Dhipaya Corona",
                Insurer: "Dhipaya",
                "Error message": "Enter-" + error.message,
                "Error code": "E10000"
              });
            }
            const dataLayer = _.get(window, "dataLayer", undefined);
            if (!!dataLayer) {
              dataLayer.push({
                event: "error-page", // Required
                errorMsg: "Enter-" + error.message
              });
            }
            const {
              history: { push }
            } = this.props;
            push("/error-common");
            document.getElementById("rootScreen").scrollTo(0, 0);
            return;
          }
          const response = _.get(error, "response", {});
          const responseStatus = response.status;
          if (
            responseStatus === 500 ||
            responseStatus === 403 ||
            responseStatus === 401 ||
            responseStatus === 400
          ) {
            const mixpanel = _.get(window, "mixpanel", undefined);
            if (!!mixpanel) {
              mixpanel.track("Insurance Corona Error", {
                "Insurance type": "Dhipaya Corona",
                Insurer: "Dhipaya",
                "Error message":
                  "Enter-" +
                  _.get(
                    response,
                    "message",
                    "Get User - Unknown error - " +
                      responseStatus +
                      " " +
                      _.get(error, "message", "")
                  ),
                "Error code": "E10001"
              });
            }
            const dataLayer = _.get(window, "dataLayer", undefined);
            if (!!dataLayer) {
              dataLayer.push({
                event: "error-page", // Required
                errorMsg:
                  "Enter-" +
                  _.get(
                    response,
                    "message",
                    "Get User - Unknown error - " +
                      responseStatus +
                      " " +
                      _.get(error, "message", "")
                  )
              });
            }
            const {
              history: { push }
            } = this.props;
            push("/error-common");
            document.getElementById("rootScreen").scrollTo(0, 0);
            return;
          }
          dispatch({
            type: "",
            isShowError: true,
            errorMessage: error.message
          });
        });
    }
    const {
      history: { push }
    } = this.props;
    push("/packages");
  };

  render() {
    return <div />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(Callback);
